import type RotateImageViewState from '../schema/RotateImageViewState';

export default function createRotateImageViewState(): RotateImageViewState {
    return {
        image: null,
        locationPoint: null,
    };
}
